import React from 'react';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const DeleteDocumentModal = ({ isOpen, onClose, onConfirm }) => {
  const handleSubmit = () => {
    onConfirm();
  };

  return (
    <StandardModal
      isOpen={isOpen}
      contentLabel="Delete Document"
      onRequestClose={onClose}
    >
      <Form onSubmit={handleSubmit}>
        <FormInstruction>
          <strong>Are you sure you want to delete this document?</strong>
          <br />
          <br />
          This action cannot be undone. Once deleted, the document and all its content will be permanently removed.
        </FormInstruction>

        <ResponsiveContainer name="form-actions">
          <FormActions>
            <Button
              variant="secondary"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="destructive"
            >
              Delete Document
            </Button>
          </FormActions>
        </ResponsiveContainer>
      </Form>
    </StandardModal>
  );
};

export default DeleteDocumentModal;